var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99818 20.8011C5.61689 20.8011 4.49714 19.6813 4.49714 18.3001V15.2988C4.49714 14.6355 4.23363 13.9993 3.7646 13.5303C3.29556 13.0613 2.65941 12.7978 1.99609 12.7978C2.65941 12.7978 3.29556 12.5343 3.7646 12.0652C4.23363 11.5962 4.49714 10.96 4.49714 10.2967V7.29548C4.49714 5.91419 5.61689 4.79443 6.99818 4.79443",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.002 4.79443C18.3832 4.79443 19.503 5.91419 19.503 7.29548V10.2967C19.503 11.678 20.6227 12.7978 22.004 12.7978C20.6227 12.7978 19.503 13.9175 19.503 15.2988V18.3001C19.503 19.6813 18.3832 20.8011 17.002 20.8011",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67328 12.8796C8.67328 12.852 8.65088 12.8296 8.62326 12.8296C8.59563 12.8296 8.57323 12.852 8.57323 12.8796C8.57323 12.9072 8.59563 12.9296 8.62326 12.9296C8.65088 12.9296 8.67328 12.9072 8.67328 12.8796",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0493 12.8708C12.0493 12.8432 12.0269 12.8208 11.9992 12.8208C11.9716 12.8208 11.9492 12.8432 11.9492 12.8708C11.9492 12.8984 11.9716 12.9208 11.9992 12.9208C12.0269 12.9208 12.0493 12.8984 12.0493 12.8708",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0512 12.8708C15.0512 12.8432 15.0288 12.8208 15.0012 12.8208C14.9736 12.8208 14.9512 12.8432 14.9512 12.8708C14.9512 12.8984 14.9736 12.9208 15.0012 12.9208C15.0288 12.9208 15.0512 12.8984 15.0512 12.8708",
    stroke: "#56708A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.0ac9da7bc99999eae83f6eac8bd4e531.svg";
export { ForwardRef as ReactComponent };